import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { semanticColors } from '../../Globals/styles';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import Workplace from './workplace';
import WorkplaceDropableSorter from './workplaceDropableSorter';
import { showSidebarConst } from '../../Globals/constants';

class Column extends Component {
  onScroll = (evt) => {
    if (evt.top >= 1 && this.props.hasPagination) {
      this.props.nextPage();
    }
  };
  render() {
    const { title, workplaceIds, params, columnIndex, draggingWorkplace, onWorkplaceDrop, showSidebar,
      sortByProject, workplaces, sortByUser } = this.props;

    let workplaceNodes = []
    workplaceIds.forEach((workplaceId, index) => {
      //if the workplaces is not yet fetched, dont do anything;
      if (!workplaces[workplaceId]) {
        return
      }

      //if its sorted by a project, and this workplace does not have this project return;
      if (sortByProject && workplaces[workplaceId].project.id !== sortByProject) {
        return;
      }
      //if its not sorted by project, and its sorted by user then if user is not on the workplace return;
      else if (!sortByProject && sortByUser ) {
        const employees = workplaces[workplaceId].employees || {}
        const filtered = Object.values(employees).some(usr => usr.id === sortByUser)
        if(!filtered) return;
      } else if (this.props.matches.length > 0) {
        if (!this.props.matches.includes(workplaceId)) { return }
      }

      workplaceNodes.push(
        <div key={workplaceId} style={styles.workplaceContainer}>
          <WorkplaceDropableSorter
            index={index}
            columnIndex={columnIndex}
            isLast={false}
            isOnlyDropTarget={false}
            draggingWorkplace={draggingWorkplace}
            onWorkplaceDrop={onWorkplaceDrop}
            workplacesLength={workplaceIds.length}
          />
          <Workplace
            key={workplaceId}
            workplaceId={workplaceId}
            params={params}
            position={{ columnIndex: columnIndex, index: index }}
            showSidebar={showSidebar}
          />
          {index + 1 === workplaceIds.length ?
            <WorkplaceDropableSorter
              index={index + 1}
              columnIndex={columnIndex}
              isLast={true}
              isOnlyDropTarget={false}
              draggingWorkplace={draggingWorkplace}
              onWorkplaceDrop={onWorkplaceDrop}
              workplacesLength={workplaceIds.length}
            />
            :
            null
          }
        </div>
      )
    })


    return (
      <div className="columnContainer" style={[styles.column, columnIndex === 0 && styles.firstColumnPadding]}>
        <h2 style={styles.h2}>{title}</h2>
        <Scrollbars style={{ width: '100%', height: '100%' }} autoHide={true} onScrollFrame={this.onScroll}>


          {workplaceNodes.length ?
            workplaceNodes
            :
            <WorkplaceDropableSorter
              index={0}
              columnIndex={columnIndex}
              isLast={false}
              isOnlyDropTarget={true}
              draggingWorkplace={draggingWorkplace}
              onWorkplaceDrop={onWorkplaceDrop}
              workplacesLength={workplaceIds.length}
            />
          }
          {this.props.hasPagination ?
            <div style={{ paddingTop: '10px', paddingBottom: '10px', cursor: 'pointer' }} onClick={() => this.props.nextPage()}>
              Indlæs flere
        </div>
            : null}
        </Scrollbars>
      </div>

    );
  }
}

var styles = {
  column: {
    position: 'relative',
    backgroundColor: semanticColors.default,
    textAlign: 'center',
    height: '100%',
    borderRadius: '2px',
    boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    padding: '47px 10px 10px 10px'
  },
  firstColumnPadding: {
    padding: '47px 10px 40px 10px'
  },
  h2: {
    backgroundColor: semanticColors.default,
    fontSize: '14px',
    fontWeight: '600',
    height: '35px',
    lineHeight: '45px',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    borderRadius: '2px'
  },
  workplaceContainer: {
    position: 'relative',
    marginBottom: '12px'
  }
}
Column.propTypes = {
  title: PropTypes.string.isRequired,
  workplaceIds: PropTypes.arrayOf(PropTypes.string.isRequired),
  columnIndex: PropTypes.number.isRequired,
  draggingWorkplace: PropTypes.string,
  onWorkplaceDrop: PropTypes.func.isRequired,
  showSidebar: PropTypes.oneOf(Object.keys(showSidebarConst)),
  sortByProject: PropTypes.string,
  workplaces: PropTypes.object,
  sortByUser: PropTypes.string,
  hasPagination: PropTypes.bool.isRequired,
  nextPage: PropTypes.func
};
export default Radium(Column)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/column.jsx